import React from 'react';
import clsx from 'clsx';
import Dropdown from './Dropdown';
import { translate } from '../Services/translation';

export function SortCriteria({ sortCriteria, className, ...props }) {
  if (!sortCriteria?.length) {
    return null;
  }

  const selectedOption =
    sortCriteria.find((x) => x.selected === true) ?? sortCriteria[0];

  return (
    <Dropdown
      {...props}
      label={translate('facet.header.sortCriteria')}
      className={clsx('facet-filter-dropdown sort-btn', className)}
    >
      {sortCriteria.map((item, idx) => (
        <Dropdown.Item key={`sortCriteriaCompact-${idx}`}>
          <a
            href={item.value}
            rel="noreferrer noopener"
            title={item.text}
            aria-label={item.text}
            className={selectedOption === item ? 'active' : ''}
          >
            {item.text}
            {selectedOption === item && (
              <svg
                width="25"
                height="25"
                viewBox="0 0 52 52"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M40.267,14.628L20.974,33.921l-9.293-9.293c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l10,10
                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l20-20c0.391-0.391,0.391-1.023,0-1.414S40.657,14.237,40.267,14.628z"
                />
              </svg>
            )}
          </a>
        </Dropdown.Item>
      ))}
    </Dropdown>
  );
}

export default SortCriteria;
